import { inject, Injectable } from '@angular/core';
import { ReportRequestBodyStrategy } from '../interfaces';
import { VerificationRequestBodyStrategy } from './mm-reports';
import { RulesUsageRequestBodyStrategy } from './dm-reports';

@Injectable({ providedIn: 'root' })
export class ReportStrategyFactory {
  private strategies: { [reportKey: string]: ReportRequestBodyStrategy } = {};

  mmVerificationStrategy = inject(VerificationRequestBodyStrategy);
  dmRulesUsageRequestStrategy = inject(RulesUsageRequestBodyStrategy);

  constructor() {
    this.strategies['mm_verification_report'] = this.mmVerificationStrategy;
    this.strategies['dm_rules_usage_report'] = this.dmRulesUsageRequestStrategy;
  }

  getStrategy(reportKey: string): ReportRequestBodyStrategy {
    return this.strategies[reportKey];
  }
}
